// lib/dialog-focus.ts
//
// Pure focus-trap math shared by the public dialogs (MobileMenu,
// CookieConsent). Kept DOM-free so it is unit-testable without a DOM test
// library (none in this repo's vitest setup).

export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Index to focus when Tab / Shift+Tab is pressed inside a trapped dialog, or
 * null when the browser's default move stays inside the dialog.
 * `current` is the index of the focused element in the dialog's focusable
 * list, or -1 when focus is outside the list (or on the dialog itself).
 */
export function trapFocusTarget(
  count: number,
  current: number,
  shiftKey: boolean,
): number | null {
  if (count <= 0) return null;
  if (current < 0) return shiftKey ? count - 1 : 0;
  if (shiftKey && current === 0) return count - 1;
  if (!shiftKey && current === count - 1) return 0;
  return null;
}
